module.exports = __webpack_public_path__ + "static/media/photo7.a25f5296.jpg";